import { createSelector } from 'reselect'

import { IFormState, TForm } from 'cng-common/features/form/models'

import { QBR_SETTINGS_FORM_KEY } from '../configs'
import { IQbrSettingsForm } from '../models/qbrSettingsForm'

export const selectQbrSettingsForm = createSelector(
  [(state: { form: IFormState<IQbrSettingsForm> }) => state.form[QBR_SETTINGS_FORM_KEY]],
  (qbrForm): TForm<IQbrSettingsForm> | undefined => {
    return qbrForm
  }
)
